export default __webpack_public_path__ + "static/media/buildingIcon.42ca98f9.svg";